/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * Serializer for the EpaFormFile model.
 * @export
 * @interface EpaFormFileCreate
 */
export interface EpaFormFileCreate {
    /**
     * 
     * @type {string}
     * @memberof EpaFormFileCreate
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof EpaFormFileCreate
     */
    file: string;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof EpaFormFileCreate
     */
    fileType: FileTypeEnum;
    /**
     * Creates upload URL based on filename field.
     * @type {string}
     * @memberof EpaFormFileCreate
     */
    readonly uploadUrl: string;
    /**
     * Returns filename to API.
     * @type {string}
     * @memberof EpaFormFileCreate
     */
    readonly filename: string;
}



/**
 * Check if a given object implements the EpaFormFileCreate interface.
 */
export function instanceOfEpaFormFileCreate(value: object): value is EpaFormFileCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('file' in value) || value['file'] === undefined) return false;
    if ((!('fileType' in (value as Record<string, any>)) && !('file_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['fileType'] === undefined && (value as Record<string, any>)['file_type'] === undefined)) return false;
    if ((!('uploadUrl' in (value as Record<string, any>)) && !('upload_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadUrl'] === undefined && (value as Record<string, any>)['upload_url'] === undefined)) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    return true;
}

export function EpaFormFileCreateFromJSON(json: any): EpaFormFileCreate {
    return EpaFormFileCreateFromJSONTyped(json, false);
}

export function EpaFormFileCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaFormFileCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'file': json['file'],
        'fileType': FileTypeEnumFromJSON(json['file_type']),
        'uploadUrl': json['upload_url'],
        'filename': json['filename'],
    };
}

export function EpaFormFileCreateToJSON(json: any): EpaFormFileCreate {
    return EpaFormFileCreateToJSONTyped(json, false);
}

export function EpaFormFileCreateToJSONTyped(value?: Omit<EpaFormFileCreate, 'id'|'uploadUrl'|'filename'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file': value['file'],
        'file_type': FileTypeEnumToJSON(value['fileType']),
    };
}

